<div class="tool-list-item-container">
    <div class="tool-picto">
        <img src="/assets/pictos/tools/{{tool.id}}.svg">
    </div>
    <p class="tool-label">{{tool.description}}</p>
</div>